<template>
  <div class="extra-cost">
    <div class="card-header bg-default">
      <strong>{{ extraCost.name }}</strong>
      <template v-if="extraCost.CarClass">
        <span class="badge badge-primary">{{ extraCost.CarClass.name }} Vehicles</span>
      </template>
      <template v-else>
        <span class="badge badge-default">Default</span>
      </template>
    </div>
    <div class="list-group list-group-flush">
      <div class="list-group-item">
         {{ extraCost.description }}
      </div>
      <div class="list-group-item">
        <template v-if="extraCost.rateType === 'rate'">
          <h4>Rates</h4>
          <p><strong>Hourly Rate:</strong> {{ extraCost.hourlyRate | to_dollar_amount }}</p>
          <p><strong>Daily Rate:</strong> {{ extraCost.dailyRate | to_dollar_amount }}</p>
          <p><strong>Weekend Rate:</strong> {{ extraCost.weekendRate | to_dollar_amount }}</p>
        </template>
        <template v-else>
          <h4>Fixed Cost</h4>
          <p><strong>Cost:</strong> {{ extraCost.cost | to_dollar_amount }}</p>
        </template>
      </div>
    </div>
    <div class="card-footer text-right">
      <router-link v-if="isFinanceAdmin" class="btn btn-sm btn-primary" :to="'/membership/rates/extras/edit/' + extraCost.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button v-else disabled class="btn btn-sm btn-default">
        <span class="fa fa-edit fa-fw"></span> Edit
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ExtraCost',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'isFinanceAdmin'
    ]),
    extraCost () {
      return {
        name: '',
        description: '',
        cost: '',
        dailyRate: '',
        hourlyRate: '',
        weekendRate: '',
        defaultRate: false,
        rateType: 'rate',
        CarClass: {
          name: ''
        },
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/ExtraCost.vue